import useSWR from "swr";
import {Utils} from "@/common/utils";
import { StandardResponse } from "@/types/swr";
import { useMemo } from "react";


const clientConfigs = Utils.getEAIClientConfigs();

export interface EnfluxTerm {
    id: number,
    school_id: string,
    name: string,
    term: string,
    term_type: string,
    calendar_year: string,
    term_order: number,
    acad_year: string,
    start_date: string,
    end_date: string,
}

export interface TermsResponse {
    data: EnfluxTerm[]
}

export function useTerms() {
    const {data, error, mutate} = useSWR<TermsResponse, Error>(`${clientConfigs.endpoint}/super_admin/schools/${clientConfigs.school}/terms`);

    if (data) {
        data.data = data.data.sort((firstTerm, secondTerm) => {
            const fED = new Date(firstTerm.end_date).getTime();
            const sED = new Date(secondTerm.end_date).getTime();
            return fED - sED;
        });
    }
    return {
        data,
        error,
        mutate
    };
}

export interface PostscriptTermSource {
    name: string,
}

export function usePostscriptTerms() {
    const {data, error, mutate} = useSWR<StandardResponse<PostscriptTermSource[]>, Error>(`${clientConfigs.endpoint}/super_admin/schools/${clientConfigs.school}/postscript/sources`);
    return {
        data,
        error,
        mutate
    };
}

export function usePostscriptTermOptions() {
    const { data, error } = usePostscriptTerms();
    return useMemo(() => {
        return {
            options: data?.data.map((source) => ({
                value: source.name,
                label: source.name,
            })),
            error,
        };
    }, [data, error]);
}
